export default {
  computed: {
    isUruguay() {
      return true;
    },
  },
};
